module.exports = __webpack_public_path__ + "static/media/massage_spa.37c2c4cc.svg";